module.exports = __webpack_public_path__ + "media/images/social/zen-yandex-e7a445aebd2e7b5bd5e6bcff3dfe0532.svg";